import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-sku',
  templateUrl: './ipos-help-sku.component.html',
  styleUrls: ['./ipos-help-sku.component.scss']
})
export class IposHelpSkuComponent implements OnInit {
  @Output() readonly sideNav = new EventEmitter();
  @Input() sideNavData;
  @ViewChild('skuDataSkuInfo') skuDataSkuInfo: ElementRef;
  @ViewChild('skuDataUploadCsv') skuDataUploadCsv: ElementRef;
  @ViewChild('skuDataComparison') skuDataComparison: ElementRef;
  isSkuDataSkuInfo = true;
  isSkuDataUploadCsv = true;
  isSkuDataComparison = true;

  constructor() { }

  ngOnInit(): void {
  }

  change(data) {
    if (data === 'skuDataSkuInfo') {
      setTimeout(() => {
        this.skuDataSkuInfo.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'skuDataUploadCsv') {
      setTimeout(() => {
        this.skuDataUploadCsv.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'skuDataComparison') {
      setTimeout(() => {
        this.skuDataComparison.nativeElement.scrollIntoView();
      }, 0);
    }
  }

  showDescription(data) {
    if(data === 'skuDataSkuInfo'){
      this.isSkuDataSkuInfo = !this.isSkuDataSkuInfo;
    }else if (data === 'skuDataUploadCsv'){
      this.isSkuDataUploadCsv = !this.isSkuDataUploadCsv;
    } else  if (data === 'skuDataComparison'){
      this.isSkuDataComparison = !this.isSkuDataComparison;
    }
  }

}
